import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import CarNavigation from '../../containers/car-navigation';
import CarNavigationLinkItem from '../../blocks/car-navigation-link-item';
import Cta from '../../containers/cta';

const CarNavigationBlock = props => <CarNavigation {...props} />;
CarNavigationBlock.displayName = 'CarNavigation';

export default withDynamicComponents({
  componentWhitelist: [
    CarNavigationLinkItem,
    Cta
  ],
  mapInputToOutput: [
    ['pageLinks', 'pageLinks'],
    ['commonLinks', 'commonLinks'],
  ],
})(CarNavigationBlock);



// WEBPACK FOOTER //
// ./src/blocks/car-navigation/index.jsx